import { getUrlWithSchema } from "@shared/common/utils/url";
import type { ExternalSiteRule } from "../../types";
import { IMWEB_PAGE, SITE_TYPE } from "./const";

const imweb: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ html, responseUrl }) => {
    if (!html.innerHTML.includes("cdn.imweb.me")) {
      return "INVALID";
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [
    {
      siteType: SITE_TYPE,
      targetValue: IMWEB_PAGE.LOGIN.target,
      label: "로그인 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${IMWEB_PAGE.LOGIN.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: IMWEB_PAGE.SIGNUP.target,
      label: "가입하기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${IMWEB_PAGE.SIGNUP.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: IMWEB_PAGE.MY_PAGE.target,
      label: "마이 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${IMWEB_PAGE.MY_PAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: IMWEB_PAGE.CART.target,
      label: "장바구니 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${IMWEB_PAGE.CART.url}`;
      },
    },
  ],
};

export default imweb;
